export const ISRESULT = 'ISRESULT';
//Main
export const GET_DATA_MAIN_PLANTEMPLATE = 'GET_DATA_MAIN_PLANTEMPLATE';
export const GET_DATA_MAIN_PLANTEMPLATE_SUCCEEDED = 'GET_DATA_MAIN_PLANTEMPLATE_SUCCEEDED';
export const REQUERT_MAIN_PLANTEMPLATE_FAILED = 'REQUERT_MAIN_PLANTEMPLATE_FAILED';
export const SET_DATA_MAIN_PLANTEMPLATE = 'SET_DATA_MAIN_PLANTEMPLATE';
//delete
export const GET_DATA_Delete_PLANTEMPLATE = 'GET_DATA_Delete_PLANTEMPLATE';
export const GET_DATA_Delete_PLANTEMPLATE_SUCCEEDED = 'GET_DATA_Delete_PLANTEMPLATE_SUCCEEDED';
export const REQUERT_Delete_PLANTEMPLATE_FAILED = 'REQUERT_Delete_PLANTEMPLATE_FAILED';
export const SET_DATA_Delete_PLANTEMPLATE = 'SET_DATA_Delete_PLANTEMPLATE';

export const GET_DATA_KHName_PLANTEMPLATE = 'GET_DATA_KHName_PLANTEMPLATE';
export const GET_DATA_KHName_PLANTEMPLATE_SUCCEEDED = 'GET_DATA_KHName_PLANTEMPLATE_SUCCEEDED';
export const REQUERT_KHName_PLANTEMPLATE_FAILED = 'REQUERT_KHName_PLANTEMPLATE_FAILED';
export const SET_DATA_KHName_PLANTEMPLATE = 'SET_DATA_KHName_PLANTEMPLATE';
//New
export const GET_DATA_NEW_PLANTEMPLATE = 'GET_DATA_NEW_PLANTEMPLATE';
export const GET_DATA_NEW_PLANTEMPLATE_SUCCEEDED = 'GET_DATA_NEW_PLANTEMPLATE_SUCCEEDED';
export const REQUERT_NEW_PLANTEMPLATE_FAILED = 'REQUERT_NEW_PLANTEMPLATE_FAILED';
export const SET_DATA_NEW_PLANTEMPLATE = 'SET_DATA_NEW_PLANTEMPLATE';
//PlanConfigByStep
export const GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE = 'GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE';
export const GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE_SUCCEEDED = 'GET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE_SUCCEEDED';
export const REQUERT_PLANCONFIGBYSTEP_PLANTEMPLATE_FAILED = 'REQUERT_PLANCONFIGBYSTEP_PLANTEMPLATE_FAILED';
export const SET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE = 'SET_DATA_PLANCONFIGBYSTEP_PLANTEMPLATE';
//Email
export const GET_DATA_EMAIL = 'GET_DATA_EMAIL';
export const GET_DATA_EMAIL_SUCCEEDED = 'GET_DATA_EMAIL_SUCCEEDED';
export const REQUERT_DATA_EMAIL_FAILED = 'REQUERT_DATA_EMAIL_FAILED';

//IndexHygen